import useThrottledGetRequest from '../../../common/services/useThrottledGetRequest';
import defaultApiWait from './defaultApiWait';
import getSpecialCharactersFilteredSearchText from '../../../common/services/getSpecialCharactersFilteredSearchText';

export default function useFindUsers(searchText) {
    const [data, isLoading, error] = useThrottledGetRequest(
        `/api/v1/users?q=${getSpecialCharactersFilteredSearchText(searchText)}`,
        {
            wait: defaultApiWait,
        },
    );

    const filteredUsers = data?.clients || [];
    const mappedUsers = filteredUsers.map(({ name, ...rest }) => ({ label: name, ...rest }));
    return [mappedUsers, isLoading, error];
}
